export const Loader = () => {
  return (
    <>
      <div className="loader-mask">
        <div className="loader">
          <div></div>
          <div></div>
        </div>
      </div>
    </>);

};